import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import router from '@/router';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
        id:null,
        email:'',
    },
    authInitialized:false,
    intendedUrl:'',
    projects:[],
  },
  mutations: {
    setIntendedUrl (state,payload) {
      state.intendedUrl = payload;
    },
    authInitialized (state) {
      state.authInitialized = true;
    },
    setUser (state,payload) {
      state.user = payload;
    }
  },
  actions: {
    setUser ({commit},user) {
      commit('setUser',user)
    },
    setIntendedUrl ({commit},url) {
      commit('setIntendedUrl',url)
    },
    authInitialized ({commit},bool) {
      commit('authInitialized',bool)
    },

  },
  getters: {
    isAuthenticated:(state) => state.authInitialized && state.user &&  state.user.id
  }
})